import React from "react";
import { useState, useEffect } from "react";
import { GET_DRIVER_BY_ID } from "./QueryDriver";
import { useApolloClient } from "@apollo/client";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import LoopIcon from '@mui/icons-material/Loop';
const ViewDriver = ({ id, onClose }) => {
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [driver, setdriver] = useState({});
  console.log(id);
  useEffect(() => {
    const getDriverById = async () => {
      try {
        const { data } = await client.query({
          query: GET_DRIVER_BY_ID,
          variables: {
            getDriverByIdId: id,
          },
          fetchPolicy: "network-only",
        });
        console.log(data.getDriverByID);
        setdriver(data.getDriverByID);
        setvisibility(true);
      } catch (error) {
        /*    setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        }); */
      }
    };
    getDriverById();
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">NOMBRES</label>
            <TextField disabled value={driver?.postulant.name} />
          </Box>
          <Box sx={style}>
            <label for="my-input">APELLIDO</label>
            <TextField disabled value={driver?.postulant.surname} />
          </Box>

          <Box sx={style}>
            <label for="my-input">EMAIL</label>
            <TextField disabled value={driver?.postulant.email.toLowerCase()} />
          </Box>
          <Box sx={style}>
            <label for="my-input">TELEFONO</label>
            <TextField disabled value={driver?.postulant.phone} />
          </Box>
          <Box sx={style}>
            <label for="my-input">DNI</label>
            <TextField disabled value={driver?.postulant.doi} />
          </Box>
          <Box sx={style}>
            <label for="my-input">FECHA DE NACIMIENTO</label>
            <TextField
              disabled
              value={new Date(driver?.postulant.dob).toLocaleDateString(
                "es-ES"
              )}
            />
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={onClose}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{ display: "flex", justifyContent: "center" }}>
    <LoopIcon />
  </Box>
  );
};

export default ViewDriver;
